export default function getFieldTypeOptions(fieldType) {
  switch (fieldType) {
    case "dropdown":
    case "dropdowngrouped":
    case "checkbox":
    case "radio":
      return [
        { label: "Dropdown", value: "dropdown" },
        { label: "Dropdown Grouped", value: "dropdowngrouped" },
        { label: "Checkbox", value: "checkbox" },
        { label: "Radio", value: "radio" },
      ]
    default:
      return []
  }
}
